export const parsePipeSeparatedString = (text: string): string[] => {
  if (!text) return [];
  return text
    .split('|')
    .map((item) => item.trim())
    .filter(Boolean);
};

export const stripHtmlTags = (text: string): string => {
  if (!text) return '';

  // Handle multiple links separated by '|'
  if (text.includes('|')) {
    return text
      .split('|')
      .map((part) => {
        const linkMatch = part.match(/<a[^>]*href=["']([^"']*)["'][^>]*>/);
        return linkMatch ? linkMatch[1] : part.replace(/<\/?[^>]+(>|$)/g, '').trim();
      })
      .filter(Boolean)
      .join('|');
  }

  // Handle single link
  const linkMatch = text.match(/<a[^>]*href=["']([^"']*)["'][^>]*>/);
  if (linkMatch) {
    return linkMatch[1];
  }

  return text.replace(/<\/?[^>]+(>|$)/g, '').trim();
};

export const getResponseByQuestionText = (
  questionText: string,
  questions: any,
  responses: any,
  getIds?: boolean,
): string => {
  // Find the question with matching text
  const question = questions?.questions?.edges?.find(
    (edge: any) => edge?.node?.questionText == questionText,
  )?.node;

  if (!question) return '';

  // Get all responses from all edges
  const allResponses = responses?.userSurveyResponses?.edges?.map((edge: any) => edge?.node) || [];

  // Find the response for this question
  const response = allResponses.find((response: any) => response?.entityId === question?.id);

  if (getIds) {
    const ids =
      response?.surveyResponse?.optionResponse?.map((option: any) => option?.optionId) || [];
    return ids.join(', ');
  }

  const textResponse =
    response?.surveyResponse?.textResponse ||
    response?.surveyResponse?.optionResponse?.map((option: any) => option?.optionText).join(', ') ||
    response?.surveyResponse?.attachments?.map((attachment: any) => attachment?.url).join('|') ||
    '';
  return stripHtmlTags(textResponse);
};

export interface CardData {
  title: string;
  responses: string[];
}
